import { useDisclosureState as t } from "../disclosure/disclosure-state.js";
function s(e) {
  return e === void 0 && (e = {}), t(e);
}
export {
  s as useDialogState
};
//# sourceMappingURL=dialog-state.js.map
